import React, { useEffect, useState } from "react";
import API from '../Services/RefundReason'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";


const RefundReasonList = () => {
    const [reason, setReason] = useState("")
    const [error, setError] = useState({});
    const [reasonList, setReasonList] = useState([])
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 10
    const [id, setId] = useState([])
    const [isEditing, setIsEditing] = useState(false);
    const [highlight, setHighlight] = useState(false);
    const [createdDate, setCreatedDate] = useState("")
    const [status, setStatus] = useState("")

    useEffect(() => {
        getRefundReasonList()
    }, [currentPage])



    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }
        switch (fieldName) {
            case "reason":
                setReason(value);
                break;
            default:
                break;
        }
    };

    const validateFields = () => {
        const errors = {};
        if (!reason.trim()) {
            errors.reason = "Refund Reason is required";
        } else if (!/^[a-zA-Z][a-zA-Z0-9 _%-&]*$/.test(reason)) {
            errors.reason = "Enter a valid Refund Reason (must start with a letter)";
        }
        // if (!(reason?.trim())) errors.reason = "Reason is required";
        setError(errors);
        return Object.keys(errors).length === 0;
    }



    const handleError = (error) => {
        // console.error("Error:", error);
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };


    const getRefundReasonList = async () => {
        try {
            const payload = {
                limit: perPage,
                pageNumber: currentPage
            };
            const response = await API.getRefundReason(payload);
            //console.log("refund reason data....", response?.data?.data?.count)
            setReasonList(response?.data?.data?.rows)
            setTotalRecords(response?.data?.data?.count)
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login")
                toast.error("Network error! Please check your internet connection.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };
    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            // getRefundReasonList();
        }
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };




    const changeStatus = async (id, currentStatus) => {
        const updatedStatus = !currentStatus;
        try {
            const response = await API.changeReasonStatus(id, updatedStatus);
            if (response.status === 200) {
                setReasonList((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `Refund reason ${updatedStatus ? "Activate" : "De-Activated"} successfully!`
                );
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            handleError(error);
        }
    };


    const handleGetData = async (reasonId) => {
        try {
            const response = await API.getRefundReason({ id: reasonId });
            const fetchedData = response?.data?.data?.rows?.[0];
           // console.log("ftechdata", fetchedData)
            if (fetchedData) {
                setHighlight(true);
                setId(fetchedData.id);
                setReason(fetchedData?.reason)
                setCreatedDate(fetchedData?.createdAt)
                setStatus(fetchedData?.status)
                setIsEditing(true);
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            } else {
                toast.error("Failed to fetch SkyCoins details.");
            }
        } catch (error) {
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };
    const updateRefundData = async () => {
        try {
            const payload = {
                reason: reason,
            };
            const response = await API.updateRefundStatus(id, payload);
          //  console.log('f', response.data)
            if (response?.status === 200) {
                toast.success(response?.data?.message);
                getRefundReasonList()
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to update Refund reason. Please try again.");
            }
        } catch (error) {
            console.error("Error updating refund :", error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            toast.error("An unexpected error occurred. Please try again later.");
        }
    }


    const handleSubmit = async () => {
        if (!validateFields()) return;
        await updateRefundData();
    };

    const handleCancel = () => {
        setReason('');
        setId(null);
        setIsEditing(false);
        window.location.reload();
    };

    return (
        <div>
            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Added Refund Reason</h4>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Refund Reason</th>
                                        <th>Status</th>
                                        <th>Created-Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reasonList.map((item, index) => (
                                        // console.log("iteemmm", item),
                                        <tr key={item.id} data-active={item?.is_active ? "true" : "false"}>
                                            <td>{(currentPage - 1) * perPage + index + 1}</td>


                                            <td>
                                                <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                    <ul className="navbar-nav navbar-nav-right">
                                                        <li className="nav-item nav-profile1">
                                                            <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <div className="nav-profile-text1">
                                                                    <p className="mb-1 text-black">
                                                                    </p>
                                                                </div>
                                                            </span>
                                                            <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                            <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalTaxView">
                                                                        View
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)}
                                                                        className="btn btn-primary btn-sm" type="button"
                                                                        data-bs-toggle="modal" data-bs-target="#myModal"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    {/* {localStorage.getItem("location_id") !== item.id && ( */}
                                                                    <button
                                                                        className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                        onClick={() => changeStatus(item.id, item.is_active)}
                                                                    >
                                                                        {item.is_active ? "De-Activate" : "Activate"}
                                                                    </button>
                                                                    {/* )} */}
                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                            <td>{item?.reason}</td>
                                            <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                            <td>
                                                {moment(item?.createdAt).format("DD-MM-YYYY")}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">
                                    {/* Previous Button */}
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {getPageNumbers().map((page, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                        >
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}

                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                </div>
            </div>
            <ToastContainer />
            <section>
                <div className="modal" id="myModal" data-bs-backdrop="static">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Update Tax Rate</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="my-1">Refund Reason <span style={{ color: "red" }}>*</span></label>
                                        <input type="text" className="form-control"
                                            // onChange={(e) => (e.target.value, "type")}
                                            value={reason}
                                            onChange={(e) => handleFieldChange(e, "reason")}
                                        ></input>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-primary" onClick={handleSubmit} >Update</button>
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="modal" id="myModalTaxView" data-bs-backdrop="static">
                    <div className="modal-dialog" style={{ width: "800px" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Refund Reason Details</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="col-lg-12 grid-margin stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered text-center">
                                                    <thead>
                                                        <tr>
                                                            <th>Refund Reason</th>
                                                            <th>Created Date</th>
                                                            <th>Status</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{reason}</td>
                                                            <td>
                                                                {moment(createdDate).format("DD-MM-YYYY")}
                                                            </td>
                                                            <td>{status ? "Active" : "De-Activated"}</td>
                                                        </tr>
                                                    </thead>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>

    );
};

export default RefundReasonList;